<div class="login-page animate">
  <div class="customer-login-wrap">
    <app-store-info></app-store-info>

    <router-outlet></router-outlet>
  </div>
</div>